import useSWR, {SWRConfiguration} from 'swr';
import letrusAPI from 'APIs/letrusAPI/axiosInstance';
import useSWRMutation from 'swr/mutation';
import {
  Composition,
  CompositionDetails,
  CompositionToSave,
  SaveCompositionErrors,
} from './types';

export function fetchComposition(
  id: number | string,
  SWRConfig?: SWRConfiguration<Composition>,
) {
  return useSWR<Composition>(
    `/api/v1/compositions/${id}/?basic=1`,
    (url) => letrusAPI(url).then((res) => res.data),
    {revalidateOnFocus: false, shouldRetryOnError: false, ...SWRConfig},
  );
}

export function uploadCompositionRequest() {
  return useSWRMutation<Composition, Error, string, CompositionToSave>(
    '/api/v1/compositions',
    async (url, {arg}) => {
      const {id, ...data} = arg;

      // uses_ai_comp = false -> NewReviewed flow
      // uses_ai_comp = true -> old revision flow
      // TODO: review this after new revision 100% rollout
      const path = data.uses_ai_comp ? '' : '/finish_composition_review_async';

      try {
        const response = await letrusAPI(`${url}/${id}${path}/`, {
          method: 'patch',
          params: {minimal: 1},
          data: {
            ...data,
            flag_finished: true,
            finished: new Date().toISOString(),
          },
        });

        return response.data;
      } catch (error: any) {
        const errorMessage = error?.message || error?.response?.data?.error;

        const saveError = SaveCompositionErrors[errorMessage];

        throw new Error(saveError?.name || '', {
          cause:
            saveError?.description ||
            'Houve um problema no envio da sua redação, tente novamente mais tarde',
        });
      }
    },
    {
      throwOnError: false,
    },
  );
}

export function createCompositionRequest() {
  return useSWRMutation<Composition, Error, string, CompositionDetails>(
    '/api/v1/compositions/',
    (url, {arg}) =>
      letrusAPI(url, {method: 'post', data: arg})
        .then((res) => res.data)
        .catch((error) => {
          throw new Error(error);
        }),
    {
      throwOnError: false,
    },
  );
}
